import React, { useState, useEffect } from "react";
import CardsView from "./view/CardsView";

const Cards: React.FC = () => {
  return (
    <div className="card-container center">
        <CardsView />
    </div>
  );
}

export default Cards;
